import React from 'react';
import { Card, Button } from 'antd';
import styled from 'styled-components';
import { withRouter } from 'react-router';
import capitalize from 'capitalize';
import { AntdPageHeader } from '@yuhuinc/ui-library';
import ApplicationTemplateWizard from 'components/tenant_application/application_templates/ApplicationTemplateWizard';

const StyledContainer = styled.div`
  padding: 0 24px;
`;

const ApplicationTemplateWizardContainer = ({ routeParams, location }) => {
  function goBack() {
    window.history.back();
  }

  const title =
    routeParams.mode === 'preview'
      ? 'This is a preview of the template'
      : 'Edit mode (you can edit applicant responses here)';

  return (
    <div className="body" role="main">
      <AntdPageHeader onBack={goBack} title={`${capitalize(routeParams.mode)} mode`} />

      <StyledContainer>
        <Card
          type="inner"
          title={title}
          extra={<Button onClick={goBack}>Exit {routeParams.mode} mode</Button>}
        >
          <ApplicationTemplateWizard
            mode={routeParams.mode}
            applicationTemplateId={routeParams.applicationTemplateId}
            applicationId={location?.query?.application_id}
            applicantId={location?.query?.applicant_id}
          />
        </Card>
      </StyledContainer>
    </div>
  );
};

export default withRouter(ApplicationTemplateWizardContainer);
